import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const fetchProducts = async () => {
  const { data } = await http.get("/products");
  return data;
};

export const fetchProduct = async (slug) => {
  const { data } = await http.get(`/products/${slug}`);
  return data;
};

export const fetchStockStatus = async (slug) => {
  const { data } = await http.get(`/stock-status/${slug}`);
  return data;
};

export const fetchNextEditionNumber = async (slug) => {
  const { data } = await http.get(`/next-edition-number/${slug}`);
  return data;
};

export const fetchReviews = async (slug, { page = 1, perPage = 5 } = {}) => {
  const { data } = await http.get(`/reviews/${slug}`, {
    params: { page, per_page: perPage },
  });
  return data;
};

export const subscribeNewsletter = async (email, source = "footer") => {
  const { data } = await http.post("/newsletter/subscribe", { email, source });
  return data;
};

export const notifyMe = async (email, productSlug) => {
  const { data } = await http.post("/notify-me", {
    email,
    product_slug: productSlug,
  });
  return data;
};

export const submitContact = async ({ name, email, message }) => {
  const { data } = await http.post("/contact", { name, email, message });
  return data;
};
